import { Button } from "@tblabs/truffle";
import { Svg } from "../Utils/Svg";


export class MenuButton extends Button
{
    constructor()
    {
        super("");
        this.Class("navbar__mobile-button");

        this.Append(
            new Svg(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-menu "><line x1="4" x2="20" y1="12" y2="12"></line><line x1="4" x2="20" y1="6" y2="6"></line><line x1="4" x2="20" y1="18" y2="18"></line></svg>`));
    }
}
